<app-isbeauth *ngIf="authEnable"></app-isbeauth>
<is-igx-app-header
  [title]="title"
  [titleLink]="titleLink"
  [subTitle]="subTitle"
  [subTitleLink]="subTitleLink"
  [subTitleColor]="subTitleColor"
  [routerItems]="true"
  (logout)="logout()"
/>
<main class="l-main" igxFlex>
  <app-message></app-message>
  <router-outlet></router-outlet>
</main>
<footer>Interserve 2024</footer>
